<bp-splash-screen *ngIf="showSplashScreen" [show]="mounting$ | async"> </bp-splash-screen>

<div #cashierOutlet></div>
